import { styled } from "@mui/material"

import { TModalVariant } from "src/types/modal/modal-variant"

export const StyledDiv = styled("div", {
    shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: TModalVariant }>(({ variant }) => ({
    padding: variant === "slide-up-w600" ? "1rem" : "0px",
}))
